import React from 'react';
import { isResponsiveValue } from '../../hooks/useResponsiveValue.js';
import { DEFAULT_AVATAR_SIZE } from '../../Avatar/Avatar.js';
import { SkeletonBox } from '../../Skeleton/SkeletonBox.js';
import classes from './SkeletonAvatar.module.css.js';
import { clsx } from 'clsx';
import '@styled-system/css';
import merge from 'deepmerge';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SkeletonAvatar = ({
  size = DEFAULT_AVATAR_SIZE,
  square,
  className,
  style,
  ...rest
}) => {
  const responsive = isResponsiveValue(size);
  const cssSizeVars = {};
  if (responsive) {
    for (const [key, value] of Object.entries(size)) {
      cssSizeVars[`--avatarSize-${key}`] = `${value}px`;
    }
  } else {
    cssSizeVars['--avatarSize-regular'] = `${size}px`;
  }
  return /*#__PURE__*/React.createElement(SkeletonBox, _extends({
    className: clsx(className, classes.SkeletonAvatar)
  }, rest, {
    "data-component": "SkeletonAvatar",
    "data-responsive": responsive ? '' : undefined,
    "data-square": square ? '' : undefined,
    style: merge(style, cssSizeVars)
  }));
};
SkeletonAvatar.displayName = "SkeletonAvatar";

export { SkeletonAvatar };
